import { Header3, Paragraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './EncumbranceDisclaimer.css';

export const EncumbranceDisclaimer = () => {
  return (
    <div className={styles['outer']}>
      <div className={styles['inner']}>
        <Header3>От банка, с обременением</Header3>
        <Paragraph1>Объект с обременением, подробности уточняйте по телефону</Paragraph1>
      </div>
    </div>
  );
};
